import { render, staticRenderFns } from "./IcoDesktopDevice.vue?vue&type=template&id=4219d566"
import script from "./IcoDesktopDevice.vue?vue&type=script&lang=js"
export * from "./IcoDesktopDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports